import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, FormContainer, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import Classes from "model";
import React from "react";
import "./styles.css"

/**
 * @function SoftTokensActivateTokenCompletionPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SoftTokensActivateTokenCompletionPage.
 */
export default function SoftTokensActivateTokenCompletionPage(props) { 
    const { nextStep } = useWorkflow() ?? {};
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        onChange: prop => value => {
            BCMSStateManagerCRUD.init(state)
            .update([ "data", prop], { value: value })
            .submit(setState);
        },
        gotToNextStep: () => nextStep()
    });

    return (
        <PageContainer className="soft-tokens-activate-token-completion-page" state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    );
}

export const getDefaultData = () => ({
    // no data for now.
});

export const getDefaultUI = () => ({
    // no ui changes for now.
});

function PageContent() {
    const { gotToNextStep } = useStateManager();
    const { state } = useBCMSContext();
    const { branding } = state ?? {};
    const { options } = branding ?? {};

    let { mobile_authenticator_name_abi22: authName = "Digipass" } = options ?? {};
    authName = authName === "undefined" ? "Digipass" : authName;

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="Activate Token" />

                <p className="text-section">Make sure you complete the registration process in the { authName } app.</p>
                <p className="text-section text-section-2">Once you have completed the process in { authName }, your device will be registered. 
                    On future logins to Online Banking, you will be prompted to use the { authName } app to generate a verification code.</p>

                <FormContainer className="small-form-width">
                    <FormButtonRow>
                        <UIButton className="secondary-button" text="Cancel" dataPoint="Soft_Tokens_Activate_Token_Completion_Page_Cancel_Button" />
                        <UIButton className="primary-button" text="Continue" dataPoint="Soft_Tokens_Activate_Token_Completion_Page_Continue_Button" onClick={ gotToNextStep } />
                    </FormButtonRow>
                </FormContainer>
            </CenterContentContainer>
        </PageContentView>
    );
}
